import axios from "axios";

// API LOCATION
const baseUrl = process.env.REACT_APP_CMS_API;

let api = axios.create({
    baseURL: baseUrl,
    //withCredentials: true,
    headers:
        {
            'Content-Type': 'application/json',
            'Authorization': ''
        }
});

api.interceptors.response.use(function (response)  {
        return response;
    }, function (error) {
        return Promise.reject(error);
})

export default api;